// The AI tool pages need a signed-in user (the backend also checks they can edit the menu, and applies the
// monthly AI allowance). Pages using this mixin render nothing until the user is confirmed, then call their
// onUserConfirmed(); anyone not signed in is sent to redirectToMenu(). Pages must define menuId() and
// redirectToMenu().
export default {
  data() {
    return {
      user_confirmed: false
    }
  },
  created() {
    this.$http.secured.get('/app_current_user')
      .then(response => {
        this.$store.commit('setUserType', response.data.user_type)
        this.user_confirmed = true
        this.onUserConfirmed()
      })
      .catch(() => this.redirectToMenu())
  }
}
